import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.season.pagenation');
import { OnInit, Input, Output, EventEmitter, OnChanges } from '@angular/core';

@Component({
    selector: 'wiz-portal-season-pagenation',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/portal.season.pagenation/view.scss */
.pagenation {
  width: 100%;
  display: flex;
  justify-content: center;
  background-color: none;
}

.btn-select {
  color: #5263FF !important;
  font: normal normal bold 16px/20px NanumSquareOTF !important;
}

.btn {
  border-radius: 32px;
  width: 30px;
  height: 30px;
  margin: 0 3px;
  border: none;
  box-shadow: none;
  font: normal normal normal 16px/20px SUIT;
  color: #848484;
}
.btn.disabled {
  opacity: 0.2;
}`],
})
export class PortalSeasonPagenationComponent implements OnInit, OnChanges {
    @Input() current: any = 1;
    @Input() start: any = 1;
    @Input() end: any = 1;
    @Input() maxlength: any = 10;
    @Output() pageMove = new EventEmitter<number>();

    public list: Array<number> = [];

    public async ngOnInit() {
        this.Math = Math;
    }

    public async ngOnChanges() {
        this.list = [];
        for (let i = 0; i < this.maxlength; i++) {
            if (this.start + i > this.end) break;
            this.list.push(this.start + i);
        }
    }

    public move(page: number) {
        this.pageMove.emit(page);
    }
}

export default PortalSeasonPagenationComponent;